import React, { useState, useEffect } from 'react'
import moment from 'moment'
import { Cell, Pie, PieChart, BarChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Loader from '../../../presentationals/Loader/Loader.component'
import { getCommunityAnalyticsMetricsByDate, getTopPerformingAssetsByDate, getDealerOverviewListByDatestatus, getAllstateListDistrictByType, DownloadDealerAgentDashboardList, getDealerAgentMapsInfoByData } from '../maketingComponents/actioncreator';
import Pagination from '@mui/material/Pagination';
import CustomMapComponent from './CustomMapsComponent';

const Linedata = [
    {
        name: 'Page A',
        uv: 4000,
        pv: 2400,
        amt: 2400,
    },
    {
        name: 'Page B',
        uv: 3000,
        pv: 1398,
        amt: 2210,
    },
    {
        name: 'Page C',
        uv: 2000,
        pv: 9800,
        amt: 2290,
    },
    {
        name: 'Page D',
        uv: 2780,
        pv: 3908,
        amt: 2000,
    },
    {
        name: 'Page E',
        uv: 1890,
        pv: 4800,
        amt: 2181,
    },
    {
        name: 'Page F',
        uv: 2390,
        pv: 3800,
        amt: 2500,
    },
    {
        name: 'Page G',
        uv: 3490,
        pv: 4300,
        amt: 2100,
    },
];

const size = 10;


export default function DealerDashboard({ pageHandler }) {
    const [stateList, setStateList] = useState([])
    const [districtList, setDistrcitList] = useState([])
    const [loader, setLoader] = useState(false)
    const [StatsData, setStatsData] = useState({})
    const [topDealersList, setTopDealersList] = useState([])
    const [dealersData, setDealersData] = useState([])
    const [dealersDataItems, setDealersDataItems] = useState(0)
    const [dealerLocaleData, setDealerLocaledata] = useState([])
    const [searchParam, setSearchParam] = useState({
        search: "",
        status: ""
    })
    const [payload, setPayload] = useState({
        startDate: moment().startOf('year').format('YYYY-MM-DD'),
        endDate: moment(new Date()).format("YYYY-MM-DD"),
        productType: "", city: "", state: ""
    })
    const [PieData, setPieData] = useState([
        { name: "Active", value: 0 },
        { name: "Inactive", value: 0 },
    ])
    const [currentPage, setCurrentPage] = useState(1)


    const handleSearchTable = (e, type) => {
        setSearchParam((prev) => ({
            ...prev,
            [type]: e
        }))
        if (type == "search") {
            const fields = {
                search: e,
                status: searchParam?.status || ""
            }
            setTimeout(() => {
                getDealerOverviewListByDatestatusFn(payload, currentPage, fields)
            }, 300)
        } else {
            const fields = {
                search: searchParam?.search,
                status: e || ""
            }
            getDealerOverviewListByDatestatusFn(payload, currentPage, fields)
        }
    }

    const handlechange = (e, type) => {
        setPayload((prev) => ({
            ...prev,
            [type]: e.target.value
        }))
        if (type == "state") {
            const ar = stateList?.filter((el) => el?.state == e.target.value)
            setDistrcitList(ar?.[0]?.cities || [])
        }
    }

    useEffect(() => {
        APicall()
    }, [])

    const APicall = () => {
        getAllstateListDistrictByTypeFn()
        getDealerAgentMapsInfoByDataFn()
        getCommunityAnalyticsMetricsByDateFn(payload?.startDate, payload?.endDate)
        getTopPerformingAssetsByDateFn(payload?.startDate, payload?.endDate)
        getDealerOverviewListByDatestatusFn(payload, currentPage, searchParam)
    }

    const getDealerAgentMapsInfoByDataFn = () => {
        const start = moment(payload?.startDate)?.format("DD-MM-YYYY");
        const end = moment(payload?.endDate)?.format("DD-MM-YYYY");
        getDealerAgentMapsInfoByData(start, end, payload?.state, payload?.city, payload?.productType, "Dealer", callback => {
            setDealerLocaledata(callback?.data ?? [])
        })
    }

    const getAllstateListDistrictByTypeFn = () => {
        getAllstateListDistrictByType("Dealer", callback => {
            setStateList(callback?.data || [])
        })
    }

    const getCommunityAnalyticsMetricsByDateFn = (sDate, eDate) => {
        const start = moment(sDate)?.format("DD-MM-YYYY");
        const end = moment(eDate)?.format("DD-MM-YYYY");
        setLoader(true)
        getCommunityAnalyticsMetricsByDate(start, end, payload?.state, payload?.city, payload?.productType, callback => {
            setLoader(false)
            if (Object.keys(callback?.data)?.length > 0) {

                setStatsData(callback?.data || {})
                setPieData([
                    { name: "Active", value: callback?.data?.communityStatusBreakdown?.activePercentage },
                    { name: "Inactive", value: callback?.data?.communityStatusBreakdown?.inactivePercentage },
                ])
            } else {
                setStatsData({})
                setPieData({ name: "Active", value: 0 },
                    { name: "Inactive", value: 0 },)
            }
        })
    }
    const getTopPerformingAssetsByDateFn = (sDate, eDate) => {
        const start = moment(sDate)?.format("DD-MM-YYYY");
        const end = moment(eDate)?.format("DD-MM-YYYY");
        setLoader(true)
        getTopPerformingAssetsByDate(start, end, payload?.state, payload?.city, payload?.productType, callback => {
            setLoader(false)
            setTopDealersList(callback?.data || [])
        })
    }
    const getDealerOverviewListByDatestatusFn = (payloads, page, searchFields) => {
        const start = moment(payloads?.startDate)?.format("DD-MM-YYYY");
        const end = moment(payloads?.endDate)?.format("DD-MM-YYYY");
        setLoader(true)
        getDealerOverviewListByDatestatus(start, end, searchFields?.status, searchFields?.search, page, size, payload?.state, payload?.city, payload?.productType, callback => {
            setLoader(false)
            setDealersData(callback?.data?.dealers || [])
            setDealersDataItems(callback?.data?.totalPages || 0)
        })
    }

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
        getDealerOverviewListByDatestatusFn(payload, value, searchParam)
    };

    const handleDownload = () => {
        const start = moment(payload?.startDate).format("DD-MM-YYYY")
        const end = moment(payload?.endDate).format("DD-MM-YYYY")
        setLoader(true)
        DownloadDealerAgentDashboardList(start, end, payload?.state, payload?.city, payload?.productType, searchParam?.status, callback => {
            setLoader(false)
        })
    }

    return (
        <>
            {
                loader ? <Loader /> : ''
            }
            <div className='dealerDashboard'>
                <div className='container-fluid' style={{ marginTop: '90px' }}>
                    <div className="row" >
                        <div className="col-sm-2 col-xs-12">
                            <label htmlFor="">Start Date</label>
                            <input type='date' className='form-control' value={payload.startDate} onChange={(e) => handlechange(e, "startDate")} />
                        </div>
                        <div className="col-sm-2 col-xs-12">
                            <label htmlFor="">End Date</label>
                            <input type='date' className='form-control' value={payload.endDate} onChange={(e) => handlechange(e, "endDate")} />
                        </div>
                        <div className="col-sm-2 col-xs-12">
                            <label htmlFor="">State</label>
                            <select className='form-control' value={payload.state} onChange={(e) => handlechange(e, "state")}>
                                <option value={""}>Select State</option>
                                {
                                    stateList?.length > 0 ? stateList?.map((val, id) => {
                                        return (
                                            <option value={val?.state}>{val?.state}</option>
                                        )
                                    })
                                        : ""}
                            </select>
                        </div>
                        <div className="col-sm-2 col-xs-12">
                            <label htmlFor="">City</label>
                            <select className='form-control' value={payload.city} onChange={(e) => handlechange(e, "city")}>
                                <option value={""}>Select City</option>
                                {
                                    districtList?.length > 0 ? districtList?.map((val) => {
                                        return (
                                            <option value={val}>{val}</option>
                                        )
                                    })
                                        : ""
                                }
                            </select>
                        </div>
                        <div className="col-sm-2 col-xs-12">
                            <label htmlFor="">Product type</label>
                            <select className='form-control' value={payload.productType} onChange={(e) => handlechange(e, "productType")}>
                                <option value="">Select Product</option>
                                <option value="L3">Three-Wheeler L3</option>
                                <option value="L5">Three-Wheeler L5</option>

                            </select>
                        </div>
                        <div className="col-sm-2 col-xs-12">
                            <button style={{
                                marginTop: '24px', padding: '10px',
                                color: " rgb(43, 120, 255)",
                                border: "1px solid rgb(43, 120, 255)",
                                backgroundColor: "rgb(255, 255, 255)",
                                marginTop: "28px",
                                padding: "10px",
                                borderRadius: "5px"
                            }}
                                onClick={() => APicall()}>
                                Apply
                            </button>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-3 col-md-6 col-xs-12">
                            <div className="topTabs">
                                <div className='customcircle' style={{ background: "#579a1d1a", padding: '19px 15px' }}>
                                    <svg width="28" height="19" viewBox="0 0 28 19" fill="#579A1D" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19.3615 8.9565C21.57 8.9565 23.47 6.9845 23.47 4.4165C23.47 1.8795 21.56 0 19.3615 0C17.1635 0 15.253 1.9205 15.253 4.437C15.253 6.9845 17.153 8.9565 19.3615 8.9565ZM7.539 9.193C9.4495 9.193 11.114 7.467 11.114 5.238C11.114 3.03 9.439 1.3965 7.539 1.3965C5.629 1.3965 3.944 3.071 3.9545 5.259C3.9545 7.467 5.6185 9.193 7.5395 9.193M1.808 18.468H9.614C8.546 16.917 9.8505 13.7945 12.059 12.0895C10.919 11.3295 9.4495 10.7645 7.529 10.7645C2.8965 10.764 0 14.184 0 17.0295C0 17.9545 0.5135 18.468 1.808 18.468ZM12.901 18.468H25.812C27.4245 18.468 28 18.0055 28 17.1015C28 14.4515 24.682 10.795 19.3515 10.795C14.031 10.795 10.713 14.4515 10.713 17.102C10.713 18.0055 11.288 18.468 12.901 18.468Z" fill="#579A1D" />
                                    </svg>
                                </div>
                                <div className='right-text'>
                                    <h3><b>{StatsData?.totalCommunity || 0}</b></h3>
                                    <h6>Total Dealers</h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-xs-12">
                            <div className="topTabs">
                                <div className='customcircle' style={{ background: "#5a57b71a", padding: '19px 15px' }}>
                                    <svg width="28" height="19" viewBox="0 0 28 19" fill="#5A57B7" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19.3615 8.9565C21.57 8.9565 23.47 6.9845 23.47 4.4165C23.47 1.8795 21.56 0 19.3615 0C17.1635 0 15.253 1.9205 15.253 4.437C15.253 6.9845 17.153 8.9565 19.3615 8.9565ZM7.539 9.193C9.4495 9.193 11.114 7.467 11.114 5.238C11.114 3.03 9.439 1.3965 7.539 1.3965C5.629 1.3965 3.944 3.071 3.9545 5.259C3.9545 7.467 5.6185 9.193 7.5395 9.193M1.808 18.468H9.614C8.546 16.917 9.8505 13.7945 12.059 12.0895C10.919 11.3295 9.4495 10.7645 7.529 10.7645C2.8965 10.764 0 14.184 0 17.0295C0 17.9545 0.5135 18.468 1.808 18.468ZM12.901 18.468H25.812C27.4245 18.468 28 18.0055 28 17.1015C28 14.4515 24.682 10.795 19.3515 10.795C14.031 10.795 10.713 14.4515 10.713 17.102C10.713 18.0055 11.288 18.468 12.901 18.468Z" fill="#5A57B7" />
                                    </svg>
                                </div>
                                <div className='right-text'>
                                    <h3><b>{StatsData?.activeCommunity || 0}</b></h3>
                                    <h6>Active Dealers</h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-xs-12">
                            <div className="topTabs">
                                <div className='customcircle' style={{ background: "#5a57b71a", padding: '19px 15px' }}>
                                    <svg width="24" height="26" viewBox="0 0 24 26" fill="#5B93FF1a" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.2205 0.0697543C1.72539 0.45946 0.973331 2.06719 1.64696 3.4338C2.34407 4.84819 4.26656 5.18825 5.40844 4.09918C6.66723 2.89869 6.246 0.779821 4.626 0.163523C4.23738 0.0156681 3.59299 -0.0273162 3.2205 0.0697543ZM11.406 0.0831905C10.7213 0.267084 10.1098 0.774014 9.81516 1.40198C9.6762 1.69821 9.66149 1.79214 9.66149 2.38425C9.66149 3.01421 9.66873 3.05344 9.85375 3.42168C10.752 5.2092 13.2944 5.17732 14.1526 3.36771C14.3223 3.00982 14.3355 2.939 14.3355 2.38425C14.3355 1.8304 14.3221 1.75833 14.1539 1.40369C13.8139 0.686622 13.1823 0.190053 12.4325 0.0502832C12.0283 -0.025039 11.7791 -0.0170683 11.406 0.0831905ZM19.614 0.0831905C18.9098 0.272322 18.3722 0.726532 18.051 1.40369C17.8827 1.75867 17.8695 1.83001 17.8695 2.38726C17.8695 2.96724 17.8769 3.00311 18.0841 3.42185C18.4441 4.14922 19.0591 4.59643 19.8688 4.71969C20.799 4.86134 21.7142 4.44402 22.2222 3.64662C22.6346 2.99924 22.6904 2.04959 22.3566 1.35524C21.8695 0.341666 20.6893 -0.205687 19.614 0.0831905ZM1.6115 5.6543C1.17471 5.76002 0.620216 6.05084 0.289845 6.34752L0 6.60781V7.4281V8.24833H3.7905H7.58099V7.45953V6.67072L7.27667 6.38327C6.92772 6.05363 6.44253 5.79105 5.94373 5.66193C5.49297 5.54527 2.08677 5.5393 1.6115 5.6543ZM9.80399 5.66238C9.35831 5.7795 8.84246 6.05175 8.50137 6.34973L8.20799 6.6061V7.42725V8.24833H12H15.792L15.7763 7.41096L15.7605 6.5736L15.4329 6.31005C15.0449 5.998 14.6113 5.77654 14.157 5.65834C13.6905 5.53696 10.2691 5.54015 9.80399 5.66238ZM18.0237 5.66113C17.5917 5.77728 17.1494 6.00654 16.7721 6.31005L16.4445 6.5736L16.4287 7.41096L16.413 8.24833H20.2065H24L23.9843 7.41096L23.9685 6.5736L23.6265 6.29821C23.2237 5.97386 22.8432 5.77978 22.3748 5.65959C21.9003 5.53793 18.4774 5.53912 18.0237 5.66113ZM1.539 10.6702C1.539 10.6871 2.21171 11.43 3.03399 12.3213L4.52893 13.9416L11.9972 13.9395L19.4655 13.9373L20.805 12.4841C21.5417 11.6849 22.2175 10.9429 22.3068 10.8352L22.469 10.6395H12.004C6.24828 10.6395 1.539 10.6533 1.539 10.6702ZM5.28458 14.7529C5.34916 14.8234 6.39243 15.9565 7.60299 17.2711L9.80399 19.6612V22.8424C9.80399 25.3622 9.81881 26.0186 9.87524 25.9996C9.91446 25.9864 10.9015 25.6827 12.0688 25.3246L14.1911 24.6735L14.1921 22.1594L14.193 19.6453L16.4587 17.1879C17.7049 15.8365 18.733 14.7069 18.7435 14.6778C18.7551 14.6453 16.1285 14.6248 11.9648 14.6248H5.1671L5.28458 14.7529Z" fill="#5B93FF" />
                                    </svg>
                                </div>
                                <div className='right-text'>
                                    <h3><b>{StatsData?.totalLeads || 0}</b></h3>
                                    <h6>Total Leads</h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-xs-12">
                            <div className="topTabs">
                                <div className='customcircle' style={{ background: "#FDD4401a", padding: '17px 15px' }}>
                                    <svg width="32" height="27" viewBox="0 0 32 27" fill="#FDD440" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M17.69 2.85286L16.51 0.332155C16.315 -0.10554 15.705 -0.12136 15.49 0.332155L14.31 2.85286L11.695 3.24837C11.23 3.32219 11.03 3.92864 11.375 4.29251L13.275 6.24368L12.825 8.99114C12.755 9.48157 13.235 9.86126 13.665 9.6345L16.01 8.32669L18.34 9.61341C18.77 9.84016 19.255 9.46048 19.18 8.97005L18.73 6.22259L20.63 4.29251C20.97 3.93391 20.775 3.32747 20.31 3.24837L17.695 2.85286H17.69ZM12.8 13.4999C11.915 13.4999 11.2 14.254 11.2 15.1874V25.3124C11.2 26.2458 11.915 26.9999 12.8 26.9999H19.2C20.085 26.9999 20.8 26.2458 20.8 25.3124V15.1874C20.8 14.254 20.085 13.4999 19.2 13.4999H12.8ZM1.6 16.8749C0.715 16.8749 0 17.629 0 18.5624V25.3124C0 26.2458 0.715 26.9999 1.6 26.9999H8C8.885 26.9999 9.6 26.2458 9.6 25.3124V18.5624C9.6 17.629 8.885 16.8749 8 16.8749H1.6ZM22.4 21.9374V25.3124C22.4 26.2458 23.115 26.9999 24 26.9999H30.4C31.285 26.9999 32 26.2458 32 25.3124V21.9374C32 21.004 31.285 20.2499 30.4 20.2499H24C23.115 20.2499 22.4 21.004 22.4 21.9374Z" fill="#FDD440" />
                                    </svg>

                                </div>
                                <div className='right-text'>
                                    <h3><b>{StatsData?.communityConversionRate || 0}</b></h3>
                                    <h6>Conversion Rate <br /> <span style={{fontSize:'12px'}}>(Total Converted Leads / Total Leads)</span></h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-xs-12">
                            <div className="topTabs">
                                <div className='customcircle' style={{ background: "#5B93FF1a", padding: '19px 15px' }}>
                                    <svg width="24" height="22" viewBox="0 0 24 22" fill="#5B93FF" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.68115 0.630248C4.34589 0.77609 4.00769 1.22151 3.93515 1.6126C3.88351 1.89135 3.849 1.92259 3.5386 1.97229C2.96766 2.06356 2.03669 2.55062 1.50698 3.03516C0.489281 3.96604 -0.00483413 5.07887 3.56416e-05 6.42889C0.00784407 8.60392 1.51134 10.4364 3.66017 10.8899C3.99636 10.9608 4.42263 11.003 4.60735 10.9836C4.93446 10.9494 4.95083 10.9603 5.23706 11.4054C5.65997 12.0629 6.40908 12.8552 7.07338 13.3477C7.80091 13.887 9.0443 14.4824 9.83396 14.6696L10.4427 14.8138V16.8555V18.8972H8.33407C6.34191 18.8972 6.20799 18.907 5.90909 19.075C5.52631 19.2901 5.23706 19.7737 5.23706 20.1986C5.23706 20.6234 5.52631 21.1071 5.90909 21.3222C6.22252 21.4983 6.27785 21.5 11.7861 21.5C17.2943 21.5 17.3496 21.4983 17.663 21.3222C18.0458 21.1071 18.3351 20.6234 18.3351 20.1986C18.3351 19.7737 18.0458 19.2901 17.663 19.075C17.3641 18.907 17.2302 18.8972 15.2381 18.8972H13.1294V16.8604V14.8236L13.8367 14.6408C14.5732 14.4504 15.6313 13.9655 16.3052 13.5093C16.8525 13.1389 17.9833 11.9719 18.3351 11.4142C18.6223 10.959 18.6365 10.9492 18.9648 10.9836C19.4524 11.0348 20.4377 10.8029 21.0874 10.484C23.432 9.33337 24.3054 6.18129 22.8866 3.99048C22.2533 3.01257 20.9915 2.11477 20.0526 1.97397C19.7202 1.9241 19.6899 1.89782 19.6371 1.61369C19.5627 1.21193 19.2225 0.772899 18.8724 0.626638C18.4629 0.455524 5.07484 0.458883 4.68115 0.630248ZM3.91962 8.23037C3.85035 8.3119 3.27672 7.93197 3.04255 7.64944C2.7261 7.26767 2.52224 6.58329 2.59898 6.16055C2.70864 5.55661 3.16572 4.91607 3.68377 4.64042C3.84858 4.55277 3.85262 4.58467 3.9019 6.37163C3.92952 7.37287 3.9375 8.2093 3.91962 8.23037ZM20.4037 5.05738C21.0163 5.70841 21.1491 6.52427 20.7643 7.27203C20.5499 7.68873 19.9477 8.23406 19.702 8.23406C19.5911 8.23406 19.579 8.15321 19.6246 7.71795C19.6542 7.43416 19.6785 6.60193 19.6785 5.8687V4.53547L19.9094 4.65638C20.0363 4.72287 20.2588 4.90331 20.4037 5.05738Z" fill="#5B93FF" />
                                    </svg>

                                </div>
                                <div className='right-text'>
                                    <h3><b>{StatsData?.agentConversionRate || 0}%</b></h3>
                                    <h6>Overall Performing Agent
                                        <br />
                                        <span style={{fontSize:'12px'}}>(Total Converted Leads / Total Leads)</span></h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-xs-12">
                            <div className="topTabs">
                                <div className='customcircle' style={{ background: "#E5024D1a", padding: '19px 15px' }}>
                                    <svg width="24" height="22" viewBox="0 0 24 22" fill="#E5024D" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.68115 0.630248C4.34589 0.77609 4.00769 1.22151 3.93515 1.6126C3.88351 1.89135 3.849 1.92259 3.5386 1.97229C2.96766 2.06356 2.03669 2.55062 1.50698 3.03516C0.489281 3.96604 -0.00483413 5.07887 3.56416e-05 6.42889C0.00784407 8.60392 1.51134 10.4364 3.66017 10.8899C3.99636 10.9608 4.42263 11.003 4.60735 10.9836C4.93446 10.9494 4.95083 10.9603 5.23706 11.4054C5.65997 12.0629 6.40908 12.8552 7.07338 13.3477C7.80091 13.887 9.0443 14.4824 9.83396 14.6696L10.4427 14.8138V16.8555V18.8972H8.33407C6.34191 18.8972 6.20799 18.907 5.90909 19.075C5.52631 19.2901 5.23706 19.7737 5.23706 20.1986C5.23706 20.6234 5.52631 21.1071 5.90909 21.3222C6.22252 21.4983 6.27785 21.5 11.7861 21.5C17.2943 21.5 17.3496 21.4983 17.663 21.3222C18.0458 21.1071 18.3351 20.6234 18.3351 20.1986C18.3351 19.7737 18.0458 19.2901 17.663 19.075C17.3641 18.907 17.2302 18.8972 15.2381 18.8972H13.1294V16.8604V14.8236L13.8367 14.6408C14.5732 14.4504 15.6313 13.9655 16.3052 13.5093C16.8525 13.1389 17.9833 11.9719 18.3351 11.4142C18.6223 10.959 18.6365 10.9492 18.9648 10.9836C19.4524 11.0348 20.4377 10.8029 21.0874 10.484C23.432 9.33337 24.3054 6.18129 22.8866 3.99048C22.2533 3.01257 20.9915 2.11477 20.0526 1.97397C19.7202 1.9241 19.6899 1.89782 19.6371 1.61369C19.5627 1.21193 19.2225 0.772899 18.8724 0.626638C18.4629 0.455524 5.07484 0.458883 4.68115 0.630248ZM3.91962 8.23037C3.85035 8.3119 3.27672 7.93197 3.04255 7.64944C2.7261 7.26767 2.52224 6.58329 2.59898 6.16055C2.70864 5.55661 3.16572 4.91607 3.68377 4.64042C3.84858 4.55277 3.85262 4.58467 3.9019 6.37163C3.92952 7.37287 3.9375 8.2093 3.91962 8.23037ZM20.4037 5.05738C21.0163 5.70841 21.1491 6.52427 20.7643 7.27203C20.5499 7.68873 19.9477 8.23406 19.702 8.23406C19.5911 8.23406 19.579 8.15321 19.6246 7.71795C19.6542 7.43416 19.6785 6.60193 19.6785 5.8687V4.53547L19.9094 4.65638C20.0363 4.72287 20.2588 4.90331 20.4037 5.05738Z" fill="#E5024D" />
                                    </svg>

                                </div>
                                <div className='right-text'>
                                    <h3><b>{StatsData?.communityConversionRate || 0}%</b></h3>
                                    <h6>Overall Performing Dealers
                                        <br />
                                         <span style={{fontSize:'12px'}}>(Total Converted Leads / Total Leads)</span></h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-xs-12">
                            <div className="topTabs">
                                <div className='customcircle' style={{ background: "#9a1d1d1a", padding: '19px 15px' }}>
                                    <svg width="28" height="19" viewBox="0 0 28 19" fill="#9a1d1d" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19.3615 8.9565C21.57 8.9565 23.47 6.9845 23.47 4.4165C23.47 1.8795 21.56 0 19.3615 0C17.1635 0 15.253 1.9205 15.253 4.437C15.253 6.9845 17.153 8.9565 19.3615 8.9565ZM7.539 9.193C9.4495 9.193 11.114 7.467 11.114 5.238C11.114 3.03 9.439 1.3965 7.539 1.3965C5.629 1.3965 3.944 3.071 3.9545 5.259C3.9545 7.467 5.6185 9.193 7.5395 9.193M1.808 18.468H9.614C8.546 16.917 9.8505 13.7945 12.059 12.0895C10.919 11.3295 9.4495 10.7645 7.529 10.7645C2.8965 10.764 0 14.184 0 17.0295C0 17.9545 0.5135 18.468 1.808 18.468ZM12.901 18.468H25.812C27.4245 18.468 28 18.0055 28 17.1015C28 14.4515 24.682 10.795 19.3515 10.795C14.031 10.795 10.713 14.4515 10.713 17.102C10.713 18.0055 11.288 18.468 12.901 18.468Z" fill="#9a1d1d" />
                                    </svg>
                                </div>
                                <div className='right-text'>
                                    <h3><b>{StatsData?.amuAgents || 0}</b></h3>
                                    <h6>Total Urja Agent</h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-xs-12">
                            <div className="topTabs">
                                <div className='customcircle' style={{ background: "#e896001a", padding: '19px 15px' }}>
                                    <svg width="28" height="19" viewBox="0 0 28 19" fill="#e89600" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19.3615 8.9565C21.57 8.9565 23.47 6.9845 23.47 4.4165C23.47 1.8795 21.56 0 19.3615 0C17.1635 0 15.253 1.9205 15.253 4.437C15.253 6.9845 17.153 8.9565 19.3615 8.9565ZM7.539 9.193C9.4495 9.193 11.114 7.467 11.114 5.238C11.114 3.03 9.439 1.3965 7.539 1.3965C5.629 1.3965 3.944 3.071 3.9545 5.259C3.9545 7.467 5.6185 9.193 7.5395 9.193M1.808 18.468H9.614C8.546 16.917 9.8505 13.7945 12.059 12.0895C10.919 11.3295 9.4495 10.7645 7.529 10.7645C2.8965 10.764 0 14.184 0 17.0295C0 17.9545 0.5135 18.468 1.808 18.468ZM12.901 18.468H25.812C27.4245 18.468 28 18.0055 28 17.1015C28 14.4515 24.682 10.795 19.3515 10.795C14.031 10.795 10.713 14.4515 10.713 17.102C10.713 18.0055 11.288 18.468 12.901 18.468Z" fill="#e89600" />
                                    </svg>
                                </div>
                                <div className='right-text'>
                                    <h3><b>{StatsData?.salesAgents || 0}</b></h3>
                                    <h6 className='custom-hover-underline' style={{ cursor: 'pointer' }} onClick={() => pageHandler("SalesAgentDashboard")}>Total Sales Agent <i className='fa fa-angle-double-right'></i></h6>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-7 col-xs-12">
                            <div className='graphcards'>
                                <h5>Top 10 Performing Dealers</h5>
                                <hr />
                                <div className="chartDiv">
                                    <ResponsiveContainer width="100%" height="100%">
                                        <BarChart
                                            width={500}
                                            height={300}
                                            data={topDealersList}
                                            barSize={30}
                                            margin={{
                                                top: 15,
                                                right: 15,
                                                left: 20,
                                                bottom: 30,
                                            }}
                                        >
                                            <CartesianGrid strokeDasharray="4 4" vertical={false} />
                                            <XAxis dataKey="communityName" tickLine={false} tick={{
                                                angle: -20,
                                                textAnchor: 'end',
                                                // dx: -10,          
                                                // dy: 5,          
                                                fontSize: 9
                                            }}
                                                interval={0}
                                            />
                                            <YAxis axisLine={false} />
                                            <Bar dataKey="numberOfLeads" fill="#014C60" />
                                            <Tooltip />
                                        </BarChart>
                                    </ResponsiveContainer>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 col-xs-12">
                            <div className='graphcards'>
                                <h5>Dealer Status Breakdown</h5>
                                <hr />
                                <div className="chartDiv">
                                    <ResponsiveContainer width="100%" height="100%">
                                        <PieChart width={400} height={400}>
                                            <Pie
                                                dataKey="value"
                                                data={PieData}
                                                cx="50%"
                                                cy="50%"
                                                outerRadius={80}
                                                label

                                            >
                                                {PieData?.length > 0 && PieData?.map((entry, index) => (
                                                    <Cell
                                                        key={`cell-${index}`}
                                                        fill={["#01647F", "#6FA6B5"][index % 2]}
                                                    />
                                                ))}
                                            </Pie>
                                            <Tooltip />
                                        </PieChart>
                                    </ResponsiveContainer>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-6 col-xs-12">
                            <div className='graphcards'>
                                <h5>Top Dealers</h5>
                                <div className="tablecard custom table-responsive">
                                    <table className='table'>
                                        <thead>
                                            <tr>
                                                <th>Top Performer</th>
                                                <th>Dealer Name</th>
                                                <th>Total Leads</th>
                                                <th>Deals Closed</th>
                                                <th>Lead Conversion</th>
                                                <th>Additional Credit View</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                topDealersList?.length > 0 ? topDealersList?.map((value, id) => {
                                                    return (
                                                        <tr key={id}>
                                                            <td>{value?.rank || "-"}</td>
                                                            <td>{value?.communityName || "-"}</td>
                                                            <td>{value?.numberOfLeads || "0"}</td>
                                                            <td>{value?.dealClosed || "0"}</td>
                                                            <td>{value?.conversionRate || "0"}</td>
                                                            <td>{value?.additionalCreditReview || "0"}</td>
                                                        </tr>
                                                    )
                                                })
                                                    : ""}

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-xs-12">
                            <div className='graphcards'>
                                <h5>Dealers Location</h5>
                                <div style={{ marginTop: '15px' }}>
                                    <CustomMapComponent dealerData={dealerLocaleData} TextType={"Dealers"} totalHeight={"345px"} showTotalDealer={true} />
                                </div>
                                <div style={{ marginTop: '15px',display:'flex',gap:'15px',justifyContent:'center',alignItems:'center' }}>
                                    <div style={{display:'flex',gap:'6px',alignItems:'center'}}>
                                        <h5 style={{fontSize:'13px',fontWeight:'400',margin:'0'}}>Conversion Rate:</h5>
                                    </div>
                                    <div style={{display:'flex',gap:'6px',alignItems:'center'}}>
                                        <div style={{ width: '10px', height: '10px', background: '#008000', borderRadius: '50%' }}></div>
                                        <h5 style={{fontSize:'13px',fontWeight:'400',margin:'0'}}>{`>= 80%`}</h5>
                                    </div>
                                    <div style={{display:'flex',gap:'6px',alignItems:'center'}}>
                                        <div style={{ width: '10px', height: '10px', background: '#66CC66', borderRadius: '50%' }}></div>
                                        <h5 style={{fontSize:'13px',fontWeight:'400',margin:'0'}}>{'>= 60%'}</h5>
                                    </div>
                                    <div style={{display:'flex',gap:'6px',alignItems:'center'}}>
                                        <div style={{ width: '10px', height: '10px', background: '#FFFF66', borderRadius: '50%' }}></div>
                                        <h5 style={{fontSize:'13px',fontWeight:'400',margin:'0'}}>{`>= 40%`}</h5>
                                    </div>
                                    <div style={{display:'flex',gap:'6px',alignItems:'center'}}>
                                        <div style={{ width: '10px', height: '10px', background: '#FFA500', borderRadius: '50%' }}></div>
                                        <h5 style={{fontSize:'13px',fontWeight:'400',margin:'0'}}>{`>= 20%`}</h5>
                                    </div>
                                    <div style={{display:'flex',gap:'6px',alignItems:'center'}}>
                                        <div style={{ width: '10px', height: '10px', background: '#FF0000', borderRadius: '50%' }}></div>
                                        <h5 style={{fontSize:'13px',fontWeight:'400',margin:'0'}}>{`< 20%`}</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-12" style={{ marginBottom: '20px' }}>
                            <div className='graphcards'>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                                    <h5>Dealer Overview Table</h5>
                                    <div style={{ display: 'flex', gap: '10px' }}>
                                        <input type='search' value={searchParam?.search} onChange={(e) => handleSearchTable(e.target.value, "search")} placeholder='Search'
                                            style={{ border: '1px solid #00000040', borderRadius: '6px', padding: '2px' }}
                                        />
                                        <select value={searchParam?.status} onChange={(e) => handleSearchTable(e.target.value, "status")}
                                            style={{ border: '1px solid #00000040', borderRadius: '6px', padding: '2px' }}
                                        >
                                            <option value={""}>Status</option>
                                            <option value={"true"}>Active</option>
                                            <option value={"false"}>Inactive</option>
                                        </select>
                                        <button className='btn btn-primary' style={{
                                            padding: '5px',
                                            color: " rgb(43, 120, 255)",
                                            border: "1px solid rgb(43, 120, 255)",
                                            backgroundColor: "rgb(255, 255, 255)",

                                            borderRadius: "5px"
                                        }} onClick={() => handleDownload()}>Download</button>
                                    </div>
                                </div>
                                <div className="tablecard custom ">
                                    <div className='table-responsive'>
                                        <table className='table'>
                                            <thead>
                                                <tr>
                                                    <th>Community Code</th>
                                                    <th>Dealer Name</th>
                                                    <th>Mobile Number</th>
                                                    <th>Email Id</th>
                                                    <th>Community Type</th>
                                                    {/* <th>Grade</th> */}
                                                    <th>Conversion %</th>
                                                    {/* <th>OEMs Assigned</th>
                                                <th>Region</th> */}
                                                    <th>Sales Agents Count</th>
                                                    <th>Urja Agents Count</th>
                                                    <th>Total Leads Assigned</th>
                                                    <th>Converted Leads</th>
                                                    <th>Auto Approved Leads</th>
                                                    <th>Manual Approved Leads</th>
                                                    <th>Auto Reject Leads</th>
                                                    <th>Manual Reject Leads</th>
                                                    <th>Additional Credit Review</th>
                                                    <th>Active Status</th>
                                                    <th>AllCLoud Pushed Count</th>
                                                    <th>AllCLoud Finance Count</th>
                                                    <th>Important</th>
                                                    <th>Added on</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    dealersData?.length > 0 ? dealersData?.map((val, id) => {
                                                        return (
                                                            <tr key={id}>
                                                                <td>{val?.communityCode || "-"}</td>
                                                                <td>{val?.dealerName || "-"}</td>
                                                                <td>{val?.mobileNumber || "-"}</td>
                                                                <td>{val?.emailId || "-"}</td>
                                                                <td>{val?.communityType || "-"}</td>
                                                                {/* <td>{val?.grade || "-"}</td> */}
                                                                <td>{val?.conversionPercentage ?? "0"}</td>
                                                                <td>{val?.salesAgentsCount ?? "0"}</td>
                                                                <td>{val?.amuAgentsCount ?? "0"}</td>
                                                                <td>{val?.totalLeads ?? "0"}</td>
                                                                <td>{val?.convertedLeads ?? "0"}</td>
                                                                <td>{val?.approvedAuto ?? "0"}</td>
                                                                <td>{val?.approvedManual ?? "0"}</td>
                                                                <td>{val?.rejectedAuto ?? "0"}</td>
                                                                <td>{val?.rejectedManual ?? "0"}</td>
                                                                <td>{val?.additionalCreditReview ?? "0"}</td>
                                                                <td>{val?.active == true ? "Yes" : "No" ?? "-"}</td>
                                                                <td>{val?.pushedAllCloudCount ?? "0"}</td>
                                                                <td>{val?.financeAllCloudCount ?? "0"}</td>
                                                                <td>{val?.important == true ? "Yes" : "No" ?? "-"}</td>
                                                                <td>{val?.addedOn ?? "-"}</td>
                                                            </tr>
                                                        )
                                                    })
                                                        : ''}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'end', marginTop: '15px' }}>
                                        <Pagination
                                            count={Math.ceil(dealersDataItems)}
                                            page={currentPage}
                                            onChange={handlePageChange}
                                            color="primary"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
